import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import LevelComp  from "./Component/LevelComp"


const Level =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <LevelComp />
        </div>
        <Footer />
        </>
    )
}

export default Level